import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import { OperationType } from './Enums';
import { IBaseCondition, ReadOnlyBaseCondition } from './IBaseCondition';
import { Field, FieldFactory, FieldFactoryFromJS, IField } from './IField';
import { NodeLocationFactory, NodeLocationFactoryFromJS } from './INodeLocation';
import { RuleFlowFactoryFromJS } from './IRuleFlow';

export interface IBaseValueEntryCondition {
	typeName: 'ValueEntryCondition';
	operation: OperationType;
	value: any;
}

export interface IValueEntryCondition extends IBaseValueEntryCondition, IBaseCondition {
	field: IField;
}

export interface ReadOnlyValueEntryCondition
	extends IBaseValueEntryCondition,
		ReadOnlyBaseCondition {
	field: Field;
}

export type ValueEntryCondition = ReadonlyRecord<ReadOnlyValueEntryCondition>;

export const ValueEntryConditionFactory = Record<ReadOnlyValueEntryCondition>({
	id: null,
	name: null,
	typeName: 'ValueEntryCondition',
	operation: 'Equals',
	value: null,
	field: FieldFactory(),
	loc: NodeLocationFactory(),
	onSuccess: null,
	onFailure: null
});

export const ValueEntryConditionFactoryFromJS = (data: IValueEntryCondition) => {
	return ValueEntryConditionFactory({
		...data,
		field: data.field ? FieldFactoryFromJS(data.field) : null,
		loc: data.loc ? NodeLocationFactoryFromJS(data.loc) : null,
		onSuccess: data.onSuccess ? RuleFlowFactoryFromJS(data.onSuccess) : null,
		onFailure: data.onFailure ? RuleFlowFactoryFromJS(data.onFailure) : null
	});
};
